export const Anonymized = 'anonymized';
export const Current = 'current';
export const Default = 'default';
export const Disabled = 'disabled';
